import React, { useState, useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import './ContactUs.css';

function SuccessScreen({ onOk }) {
    return (
        <div className="overlay">
            <div className="success-card glass-panel">
                <h2>🎉 Message Sent!</h2>
                <p style={{ marginBottom: '24px', color: '#888' }}>Thank you for reaching out. We will get back to you shortly.</p>
                <button onClick={onOk}>Return</button>
            </div>
        </div>
    );
}

function ContactUs() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [submitError, setSubmitError] = useState('');
    const containerRef = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from(".contact-header > *", {
                y: 20,
                opacity: 0,
                duration: 1,
                stagger: 0.1,
                ease: "power2.out"
            });
            gsap.from(".contact-form-wrapper", {
                y: 40,
                opacity: 0,
                duration: 1,
                ease: "power3.out",
                delay: 0.3
            });
        }, containerRef);
        return () => ctx.revert();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const isFormValid = () => {
        if (!formData.name || !formData.email || !formData.subject || !formData.message) {
            setSubmitError('⚠️ All fields are required.');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isFormValid()) return;

        // Same Google Form Logic
        const googleFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSe8AGbLU2DwXLB2UsYMcjr2h0l4HMiQH9mK_YEHoNWmjK5TYA/formResponse';
        const submitData = new FormData();
        submitData.append('entry.2042123984', formData.name);
        submitData.append('entry.392015165', formData.email);
        submitData.append('entry.2062776782', formData.subject);
        submitData.append('entry.1339814012', formData.message);

        try {
            await fetch(googleFormUrl, {
                method: 'POST',
                body: submitData,
                mode: 'no-cors'
            });
            setIsSubmitted(true);
            setSubmitError('');
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
            console.error("Form submission error:", error);
            setIsSubmitted(false);
            setSubmitError('⚠️ An error occurred while submitting the form.');
        }
    };

    return (
        <div className="contact-page" ref={containerRef}>
            {isSubmitted && <SuccessScreen onOk={() => setIsSubmitted(false)} />}

            <div className="contact-container">
                <div className="contact-header">
                    <h1>Get in Touch</h1>
                    <p>Have a question or want to collaborate? We'd love to hear from you.</p>
                </div>

                <div className="contact-form-wrapper glass-panel">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="John Doe"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="john@example.com"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="subject">Subject</label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                placeholder="Collaboration Request"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="How can we help you?"
                            />
                        </div>
                        <button type="submit" className="submit-btn">Send Message</button>
                    </form>
                    {submitError && <div className="error-message">{submitError}</div>}
                </div>
            </div>
        </div>
    );
}

export default ContactUs;
